import { render } from "./UserAccountModal.vue?vue&type=template&id=288d1eb4&scoped=true"
import script from "./UserAccountModal.vue?vue&type=script&lang=js"
export * from "./UserAccountModal.vue?vue&type=script&lang=js"

import "./UserAccountModal.vue?vue&type=style&index=0&id=288d1eb4&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288d1eb4"]])

export default __exports__